<!-- 
Toggle for changing how the history for a levy collection provider is displayed (timeline, status changes timeline or normal listing)
-->
<template>
  <v-toolbar dense flat color="white" class="pl-1">
    <v-btn-toggle 
      :value="toggleButtonValue"
      class="mb-2 mt-2 elevation-0"
      style="border: 1px solid #f0f0f0;" mandatory 
      @change="toggle"
    >
      <v-tooltip top>
        <v-btn slot="activator" flat color="primary">
          <v-icon>timeline</v-icon>
        </v-btn>
        <span>Timeline view</span>
      </v-tooltip>
      <v-tooltip top>
        <v-btn slot="activator" flat color="primary">
          <v-icon>ballot</v-icon>
        </v-btn>
        <span>Status change view</span>
      </v-tooltip>
      <v-tooltip top>
        <v-btn slot="activator" flat color="primary">
          <v-icon>list</v-icon>
        </v-btn>
        <span>List view</span>
      </v-tooltip>
    </v-btn-toggle>
    <our-search-button 
      v-if="!timeline"
      :criteria="criteria" 
      :criteria-mutation="criteriaMutation" 
      :search-filters="searchFilters" 
      title="Search levy collection provider history"
      flat
      show-all
      @changed="$emit('changed')"
    />
    <our-saved-searches-menu
      v-if="!timeline"
      :criteria="criteria"
      :criteria-mutation="criteriaMutation"
      :clear-criteria-mutation="clearCriteriaMutation"
      module="systemLogs" 
      color="primary"
      flat dense
      @selected="$emit('changed')"
    />
    <v-spacer/>
    <div v-if="timeline">
      <our-icon-button
        icon="unfold_more"
        tooltip="Expand all"
        @click="$emit('click:expand')"
      >
        Expand all
      </our-icon-button>
      <our-icon-button
        icon="unfold_less"
        tooltip="Collapse all"
        @click="$emit('click:collapse')"
      >
        Collapse all
      </our-icon-button>
      <our-icon-button
        :icon-class="'expand-icon ' + (ascending ? 'flipped' : '')"
        tooltip="Click to toggle between ascending and descending order"
        icon="sort"
        @click="$emit('update:ascending', !ascending)"
      >
        Sorting
      </our-icon-button>
    </div>
  </v-toolbar>
</template>

<script>
/* 
Toggle buttons for the history timeline
---------------------------------------

Shows buttons for toggling between the timeline, status change and listing views of history.
When showing the timeline or status change view it also displays expand, collapse and sorting buttons.
When showing the listing view it also displays search and saved search buttons.
*/
import * as mutation from "@/store/system-logs/mutation-types";
import { getSearchFilters } from "@/store/system-logs/helpers";

export default {
  model: {
    prop: "timeline",
    event: "update:timeline"
  },
  props: {
    timeline: {
      type: Boolean,
      default: true
    },
    ascending: {
      type: Boolean,
      default: true
    },
    statusChangesOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA
    };
  },
  computed: {
    toggleButtonValue() {
      if (this.timeline) {
        return this.statusChangesOnly ? 1 : 0;
      }
      return 2;
    },
    searchFilters() {
      return getSearchFilters("LevyCollectionProviderAction", true);
    },
    criteria() {
      return this.$store.state.systemLogs.listing.criteria;
    }
  },
  methods: {
    toggle(e) {
      switch (e) {
        case 0:
          this.$emit("update:timeline", true);
          this.$emit("update:statusChangesOnly", false);
          break;
        case 1:
          this.$emit("update:timeline", true);
          this.$emit("update:statusChangesOnly", true);
          break;
        case 2:
          this.$emit("update:timeline", false);
          break;
      }
    }
  }
};
</script>
